module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mainLogo-0d37998085422cf2fcdebe4f6cd35509.png";